import React, { useState, useEffect } from 'react';
import { Grid } from 'components/lib';
import { useNavigate, useParams } from 'react-router-dom';
import { changeFormatOfDate } from 'utils/changeFormatOfDate';
import { getProject, getProjectUsers, updateProject } from '../../api/projectApi';
import ReviewHeader from 'views/project-page/components/ReviewHeader';

type ProjectReviewNode = Awaited<ReturnType<typeof getProject>> & {
  analysisType?: string;
  createdAt?: string | Date;
  owner?: {
    userId?: string | number;
    name?: string;
  } | null;
};

const ProjectReview: React.FC = () => {
  const navigate = useNavigate();

  const [project, setProject] = useState<ProjectReviewNode | null>(null);
  const [description, setDescription] = useState('');

  const { projectId } = useParams<{ projectId: string }>();

  useEffect(() => {
    const loadProject = async () => {
      try {
        const [response, users] = await Promise.all([
          getProject(projectId as string),
          getProjectUsers(projectId as string),
        ]);
        const owner = users?.find(
          (user: { isProjectOwner?: boolean; name?: string; id?: string | number }) => user.isProjectOwner
        );
        const normalizedProject = {
          ...response,
          owner: owner ? { userId: owner.id, name: owner.name } : null,
        };

        setProject(normalizedProject);
        setDescription(normalizedProject?.description || '');
      } catch (error) {
        console.error('Error fetching project:', error);
      }
    };

    loadProject();
  }, [projectId]);

  console.log('project', project);
  const projectEditableItem = project ? { ...project } : { id: projectId, name: '', description: '' };

  return (
    <div className="onboarding-container">
      <ReviewHeader
        name={project?.name}
        description={description}
        item={projectEditableItem}
        onEditDescription={setDescription}
        onSaveDescription={(value) => updateProject(projectId as string, { description: value })}
        onClose={() => {
          navigate('/dashboard');
        }}
      />

      <Grid cols="2" extraClass="review-list">
        {project?.address?.trim() && (
          <div className="review-line">
            <span className="review-subtitle">Address :</span>
            <span className="review-value">{project.address}</span>
          </div>
        )}
        <div className="review-line">
          <span className="review-subtitle">Created at : </span>
          <span className="review-value">{changeFormatOfDate(project?.createdAt)}</span>
        </div>
        <div className="review-line">
          <span className="review-subtitle">Owner :</span>
          <span className="review-value">{project?.owner?.name ?? '-'}</span>
        </div>
      </Grid>
    </div>
  );
};

export default ProjectReview;
